import { AutocompleteResult } from "../search-box/models/auto-complete-result";

export function parseAutocompleteFieldValue(
	fieldValue: string,
): AutocompleteResult {
	var valuePieces = fieldValue.split("|");

	return {
		text: valuePieces[0],
		url: valuePieces[1],
		lat: Number.parseFloat(valuePieces[2]),
		lng: Number.parseFloat(valuePieces[3]),
		zip: Number.parseInt(valuePieces[4]),
		synonyms: valuePieces[5],
	};
}
